import React from "react";
import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useTranslation } from "react-i18next";

const EmptyWorkflowState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      sx={{
        textAlign: "center",
        py: 8,
        px: 4,
        backgroundColor: "rgba(255,255,255,0.95)",
        backdropFilter: "blur(10px)",
        borderRadius: 3,
        boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
        maxWidth: 600,
        mx: "auto",
        mt: 4,
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      }}
    >
      <CardContent>
        <Box sx={{ position: "relative", mb: 4 }}>
          <AccountTreeIcon
            sx={{
              fontSize: 80,
              color: "#6a11cb",
              opacity: 0.8,
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%": {
                  transform: "scale(1)",
                  opacity: 0.8,
                },
                "50%": {
                  transform: "scale(1.05)",
                  opacity: 1,
                },
                "100%": {
                  transform: "scale(1)",
                  opacity: 0.8,
                },
              },
            }}
          />
          <AutoAwesomeIcon
            sx={{
              position: "absolute",
              top: -10,
              right: "35%",
              fontSize: 30,
              color: "#ffd89b",
              animation: "sparkle 3s ease-in-out infinite",
              "@keyframes sparkle": {
                "0%, 100%": {
                  opacity: 0,
                  transform: "scale(0.5) rotate(0deg)",
                },
                "50%": {
                  opacity: 1,
                  transform: "scale(1) rotate(180deg)",
                },
              },
            }}
          />
        </Box>

        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontWeight: 700,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 2,
          }}
        >
          {t("no_workflows_yet")}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 4,
            maxWidth: 400,
            mx: "auto",
            lineHeight: 1.6,
          }}
        >
          {t("no_workflows_description_beautiful")}
        </Typography>

        <Box
          sx={{
            p: 3,
            backgroundColor: "rgba(106, 17, 203, 0.05)",
            borderRadius: 2,
            border: "1px dashed rgba(106, 17, 203, 0.3)",
            mb: 3,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "#6a11cb", fontWeight: 500 }}
          >
            <AutoAwesomeIcon
              sx={{ fontSize: 16, verticalAlign: "middle", mr: 1 }}
            />
            {t("jess_will_help")}
          </Typography>
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 2 }}
        >
          {t("workflows_appear_automatically")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EmptyWorkflowState;
